import { useContext, useEffect, useState } from "react";
import { createContext } from "react";
import { getAnalisisId, getElementoPorId, getValorParametros, getParametrosAnalisisPlanta, getElementoPlantaPorId, getElementosPlanta, getConfNivelesPlantasCliente, bajarPdfNoFQ, getParametrosElementoPlantaCliente, bajarPdfDashBoard, bajarPdfInstrucciones, getFicheros, putValorParametros } from "../api";
import Swal from "sweetalert2";
import { AuthContext } from "./AuthContext";
import { useOnlineStatus } from "../hooks/useSync";
import { db } from "../libraries/db";

export const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {

    const [parametrosAnalisis, setParametrosAnalisis] = useState([]);

    const [listaPlantaFiltrada, setListaPlantaFiltrada] = useState([]);
    const [listaParametros, setListaParametros] = useState([]);
    const [valoresParametros, setValoresParametros] = useState([]);
    const [valoresParametrosNoFQ, setValoresParametrosNoFQ] = useState([]);
    const [analisisParametros, setAnalisisParametros] = useState([]);

    const [ficherosAll, setFicheros] = useState([]);

    const [parametrosFiltrados, setParametrosFiltrados] = useState([]);
    const [parametrosFiltradosNoFQ, setParametrosFiltradosNoFQ] = useState([]);
    const [parametrosPlantaCliente, setParametrosPlantaCliente] = useState([]);

    // Valores activos
    const [elementoActivo, setElementoActivo] = useState({});
    const [parametroActivo, setParametroActivo] = useState({});
    const [analisisActivo, setAnalisisActivo] = useState({});

    // Valores generales para punto 15 bloque 6
    const [elementosGeneral, setElementosGeneral] = useState({});

    const { user } = useContext(AuthContext);

    /*** EFECTOS ***/

    const isOnline = useOnlineStatus();

    useEffect(() => {
        if (!elementoActivo.id) {
            setParametrosFiltrados([]);
            return;
        }

        setParametrosFiltrados(
            parametrosAnalisis
                .filter(parametro => parametro.elemento === elementoActivo.id)
                .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        );
    }, [elementoActivo.id, parametrosAnalisis]);

    const GetParametrosAnalisisPlanta = async () => {
        try {
            if (isOnline) {
                // ONLINE: Hacer petición a la API
                const resp = await getParametrosAnalisisPlanta();
                setParametrosAnalisis(resp.filter(param => !param.deleted));
            } else {
                // OFFLINE: Leer desde base de datos local
                const resp = await db.table('GES_ParametrosAnalisisPlanta').toArray();
                setParametrosAnalisis(resp.filter(param => !param.deleted));
                console.log('📦 Parámetros análisis cargados desde BD local');
            }
        } catch (error) {
            console.error('Error cargando parámetros análisis:', error);
        }
    }

    const GetFicheros = async () => {

        const resp = await getFicheros();
        setFicheros(resp.filter(param => !param.deleted));

    }

    const GetValoresParametros = async () => {
        try {
            if (isOnline) {
                // ONLINE: Hacer petición a la API
                const resp = await getValorParametros();
                setListaParametros(resp.filter(valor => !valor.deleted));
            } else {
                // OFFLINE: Leer desde base de datos local
                const resp = await db.table('GES_ValorParametros').toArray();
                setListaParametros(resp.filter(valor => !valor.deleted));
                console.log('📦 Valores parámetros cargados desde BD local');
            }
        } catch (error) {
            console.error('Error cargando valores parámetros:', error);
        }
    }

    const GetParametrosElementoPlanta = async () => {
        try {
            if (isOnline) {
                // ONLINE: Hacer petición a la API
                const resp = await getParametrosElementoPlantaCliente();
                setParametrosPlantaCliente(resp.filter(param => !param.deleted));
            } else {
                // OFFLINE: Leer desde base de datos local
                const resp = await db.table('GES_ParametrosElementoPlanta').toArray();
                setParametrosPlantaCliente(resp.filter(param => !param.Deleted));
                console.log('📦 Parámetros elemento planta cargados desde BD local');
            }
        } catch (error) {
            console.error('Error cargando parámetros elemento planta:', error);
        }
    }

    /*** FUNCIONES ***/

    const handleSeleccionarElemento = async (id) => {

        let elemento;
        
        try {
            if (isOnline) {
                // ONLINE: Obtener de la API
                elemento = await getElementoPlantaPorId(id);
            } else {
                // OFFLINE: Obtener de IndexedDB buscando por el campo 'id', no por la clave primaria
                elemento = await db.table('GES_ElementosPlanta').where('id').equals(id).first();
                if (!elemento) {
                    console.warn('⚠️ Elemento no encontrado en BD local con id:', id);
                    return;
                }
            }
        } catch (error) {
            console.error('Error obteniendo elemento:', error);
            // Intenta fallback offline si hay error
            if (isOnline) {
                elemento = await db.table('GES_ElementosPlanta').where('id').equals(id).first();
                if (!elemento) {
                    console.error('❌ No se pudo obtener el elemento');
                    return;
                }
            }
        }
        
        console.log('Seleccionando un nuevo elemento:', elemento);
        
        if (elemento.descripcion !== null && elemento.descripcion?.trim() !== '') {
            setElementoActivo(prev => ({ ...prev, nombre: elemento.nombre + ' ' + elemento.descripcion, id }));
        } else {
            setElementoActivo(prev => ({ ...prev, nombre: elemento.nombre + ' ' + elemento.numero, id }));
        }

        setValoresParametros(listaParametros.filter(param => param.id_Elemento === id));
        setValoresParametrosNoFQ(parametrosAnalisis.filter(param => param.elemento === id));

        //parametros Analisisi Ordenados por fecha descendente 
        setParametrosFiltrados(parametrosAnalisis
            .filter(an => an.elemento === id)
            .sort((a, b) => {
                const valorA = new Date(a.fecha);
                const valorB = new Date(b.fecha);

                if (valorA < valorB) {
                    return parametrosAnalisis ? 1 : -1;
                }
                if (valorA > valorB) {
                    return parametrosAnalisis ? -1 : 1;
                }
            }
            )
        );

        setAnalisisActivo({})
    }

    //AMF INI MODIFICACION PUNTO 15

    const handleCargarTodosElementosPlanta = async (idPlanta, oferta) => {
        if (idPlanta === undefined || oferta === undefined) {
            setElementosGeneral({});
            return;
        }
        try {
            let elementosTodos, confElementosPlanta;

            if (isOnline) {
                // ONLINE: Hacer petición a la API
                elementosTodos = await getElementosPlanta();
                confElementosPlanta = await getConfNivelesPlantasCliente();
            } else {
                // OFFLINE: Leer desde base de datos local
                elementosTodos = await db.table('GES_ElementosPlanta').toArray();

                confElementosPlanta = await db.table('GES_Conf_NivelesPlantasCliente').toArray();
                console.log('📦 Elementos planta cargados desde BD local');
            }

            let result = [];
            if (user.idPerfil === 4) {
                confElementosPlanta = confElementosPlanta.filter(elm => elm.oferta === oferta && elm.id_Planta === idPlanta && !elm.deleted);
                confElementosPlanta.map((element, index) => {
                    let elementoFiltrado = elementosTodos.find(elm => elm.id === element.id_Elemento && elm.verInsp && !elm.deleted);
                    if (elementoFiltrado != undefined) {
                        result.push(elementoFiltrado);
                    }
                });
            } else {
                confElementosPlanta = confElementosPlanta.filter(elm => elm.oferta === oferta && elm.id_Planta === idPlanta && !elm.deleted);
                confElementosPlanta.map((element, index) => {
                    let elementoFiltrado = elementosTodos.find(elm => elm.id === element.id_Elemento && !elm.deleted);
                    result.push(elementoFiltrado);
                });
            }

            setElementosGeneral(result);
        } catch (error) {
            console.error('Error cargando elementos de la planta:', error);
        }
    }

    const GetParametrosFiltradosSinSeleccionarElemento = (id) => {
        setValoresParametros(listaParametros.filter(param => param.id_Elemento === id));
        setValoresParametrosNoFQ(parametrosAnalisis.filter(param => param.elemento === id));

        //parametros Analisisi Ordenados por fecha descendente
        setParametrosFiltrados(parametrosAnalisis
            .filter(an => an.elemento === id)
            // .sort((a,b) => {
            //     const valorA = new Date(a.fecha);
            //     const valorB = new Date(b.fecha);

            //     if (valorA < valorB) {
            //         return parametrosAnalisis ? 1 : -1;
            //     }
            //     if (valorA > valorB) {
            //         return parametrosAnalisis ? -1 : 1;                    
            //     }
            // }
        )
            ;
    }
    //AMF FIN

    const handleSeleccionarAnalisis = async (id) => {

        let analisi;
        if (isOnline) {
            // ONLINE: Hacer petición a la API
            analisi = await getAnalisisId(id);
        } else {
            // OFFLINE: Leer desde base de datos local
            analisi = await db.table('GES_Analisis').where('id').equals(id).first();
        }

            // Guard: si no encuentra el análisis, salimos
        if (!analisi) {
            console.warn('⚠️ Análisis no encontrado con id:', id);
            return;
        }

        setAnalisisActivo(prev => ({ ...prev, nombre: analisi.nombre, tipo: analisi.tipo, id }));
        setAnalisisParametros(valoresParametros.filter(param => param.id_Analisis === id));
        setParametrosFiltradosNoFQ(valoresParametrosNoFQ.filter(param => param.analisis === id));
        setListaPlantaFiltrada(parametrosPlantaCliente.filter(param => param.id_Analisis === id))

    }

    const descargarPdf = async (id, fecha) => {

        const analisi = await getAnalisisId(id);

        const date = new Date(fecha);
        // Obtener el año, mes y día
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses en JavaScript son de 0 a 11
        const day = String(date.getDate()).padStart(2, '0');

        // Formatear la fecha en YYYY-MM-DD
        const formattedDate = `${year}-${month}-${day}`;

        const tarea = valoresParametrosNoFQ.filter(param => {
            // Extraer solo la parte de la fecha (YYYY-MM-DD) del registro
            const recordDate = param.fecha.split('T')[0];
            return param.analisis === id && recordDate === formattedDate;
        })[0];

        const fichero = ficherosAll.filter(fich => fich.id === tarea.pdf)[0]
        if (fichero !== null && fichero !== undefined) {
            if (isOnline) {
                await bajarPdfDashBoard(fichero.id, fichero.name, { headers: { 'Content-type': 'application/pdf' } })
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'info',
                    title: 'No disponible offline',
                    text: `No se puede descargar PDF en modo offline`,
                    showConfirmButton: true
                });
            }
        } else {
            Swal.fire({
                position: 'center',
                icon: 'info',
                title: 'Pdf no encontrado',
                text: `Esta tarea no tiene ningún pdf adjunto`,
                showConfirmButton: true
            });
        }
    }

    const toggleRealizado = async (id, fecha) => {
        try {
            const date = new Date(fecha);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;

            let tarea = parametrosAnalisis.filter(param => {
                const recordDate = param.fecha.split('T')[0];
                return param.analisis === id && recordDate === formattedDate;
            })[0];

            // Si no existe en parametrosAnalisis, buscamos en valoresParametrosNoFQ
            if (!tarea) {
                tarea = valoresParametrosNoFQ.filter(param => {
                    const recordDate = param.fecha.split('T')[0];
                    return param.analisis === id && recordDate === formattedDate;
                })[0];
            }

            if (!tarea) {
                Swal.fire({
                    position: 'center',
                    icon: 'info',
                    title: 'Tarea no encontrada',
                    text: `No se ha encontrado la tarea para la fecha seleccionada.`,
                    showConfirmButton: true
                });
                return;
            }

            const toggled = {
                ...tarea,
                realizado: !tarea.realizado,
                fechaRealizado: !tarea.realizado ? new Date().toISOString() : null
            };

            await putValorParametros(toggled);

            // Actualizamos el estado local para que la UI refleje el cambio inmediatamente
            setParametrosAnalisis(prev => prev.map(p => (p.id === toggled.id ? toggled : p)));
            setParametrosFiltrados(prev => prev.map(p => (p.id === toggled.id ? toggled : p)));
            setValoresParametrosNoFQ(prev => prev.map(p => (p.id === toggled.id ? toggled : p)));

        } catch (error) {
            console.error(error);
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'No se ha podido actualizar la tarea.'
            });
        }
    }

    const handleSeleccionarParametro = (datos) => {
        setParametroActivo(datos);
    }

    return (
        <DashboardContext.Provider value={{
            elementoActivo,
            elementosGeneral,
            parametroActivo,
            analisisActivo,
            parametrosFiltrados,
            valoresParametros,
            analisisParametros,
            setAnalisisActivo,
            setElementoActivo,
            setParametroActivo,
            handleSeleccionarElemento,
            handleCargarTodosElementosPlanta,
            handleSeleccionarParametro,
            handleSeleccionarAnalisis,
            GetParametrosAnalisisPlanta,
            GetValoresParametros,
            GetParametrosElementoPlanta,
            valoresParametrosNoFQ,
            parametrosFiltradosNoFQ,
            parametrosAnalisis,
            listaPlantaFiltrada,
            GetParametrosFiltradosSinSeleccionarElemento,
            descargarPdf,
            toggleRealizado,
            ficherosAll,
            GetFicheros
        }}>
            {children}
        </DashboardContext.Provider>
    )
}